import { useCallback, useEffect, useState } from 'react';
import { fetchDataAuthenticated } from '../utilities/HttpUtils';

export function usePrivileges() {
    const [contributor, setContributor] = useState();
    const [admin, setAdmin] = useState();

    const getPrivileges = useCallback(() => {
        getAuthenticatedAccountPrivilege("Contributor", setContributor);
        getAuthenticatedAccountPrivilege("Admin", setAdmin);
    }, []);

    useEffect(() => {
        getPrivileges();
    }, [getPrivileges]);

    function getAuthenticatedAccountPrivilege(privilegeName, setState) {
        fetchDataAuthenticated(`api/user/checkPrivilege?privilegeName=${privilegeName}`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(accountHasPrivilege => {
                setState(accountHasPrivilege);
            })
            .catch(error => {
                console.error(error);
            });
    };

    return { contributor, admin };
}

export function useListPrivileges() {
    const [privileges, setPrivileges] = useState();

    useEffect(() => {
        getPrivileges();
    }, []);

    function getPrivileges() {
        fetchDataAuthenticated(`api/user/privileges`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setPrivileges(data);
            })
            .catch(error => {
                console.error(error);
            });
    };

    return { privileges };
}

export function useUserAreas() {
    const [areas, setAreas] = useState();

    useEffect(() => {
        getUserAreas();
    }, []);

    function getUserAreas() {
        fetchDataAuthenticated(`api/user/areas`)
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setAreas(data);
            })
            .catch(error => {
                console.error(error);
            });
    };

    return { areas };
}
